import classNames from 'classnames';
import React from 'react';

import CloseBtn from './controls/close';
import SubTitle from './controls/sub-title';

export interface IProps {
  className?: string;
  closable?: boolean;
  subTitle?: React.ReactNode;
  title?: React.ReactNode;

  onClose?: () => void;
  onCancel?: () => void;
}

const DialogHeader: React.FC<IProps> = (props) => {
  const { className: propClassName, subTitle, title, closable, onCancel, onClose } = props;

  const className = React.useMemo<string>(() => {
    return classNames('flex justify-between shrink-0', propClassName);
  }, [propClassName]);

  return (
    <div className={className}>
      <div className="flex flex-col">
        <h3 className="text-lg font-semibold text-gray-600 ">{title}</h3>
        {!!subTitle && <SubTitle>{subTitle}</SubTitle>}
      </div>
      {closable && <CloseBtn onCancel={onCancel} onClose={onClose} />}
    </div>
  );
};

DialogHeader.defaultProps = {
  closable: false
};

export default DialogHeader;
